import { Box, Flex, Heading, Text } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import QstWrapper from './components/QstWrapper'
import CategoriesMenuBar from './components/CategoriesMenuBar'
import Video from './Video'
import { useLocation, useParams } from 'react-router-dom'
import Finish from './components/Finish'
import PatientLoading from 'src/components/loading/PatientLoading'
import { useAppDispatch, useAppSelector } from 'src/redux/hooks'
import { getPatientQuestions } from 'src/view-models/Question'
import LanguagesBar from './components/LanguagesBar'

const Welcome = () => {
  const { id } = useParams()
  const { pathname } = useLocation()
  const uuid = pathname.split("/")[2]
  const [errMsg, setErrMsg] = useState<string | null>(null)
  const { patientQuestions, isPatientWatchedVideo,descriptions,patientLanguage } = useAppSelector((state) => state.question)
  const [isVideo, setIsVidoe] = useState(isPatientWatchedVideo)
  const localStorageLanguge = localStorage.getItem("language")
  const patienteLanguage = localStorageLanguge ? JSON.parse(localStorageLanguge) : patientLanguage ? patientLanguage : null
  const [isLoadingTranslate,setIsLoadingTranslate] = useState(false)

  useEffect(() => {
    setIsVidoe(isPatientWatchedVideo)
  }, [isPatientWatchedVideo])

  const dispatch = useAppDispatch()
  const [isLoading, setIsLoading] = useState(true)
  useEffect(() => {
    if(patientLanguage && localStorageLanguge && patientLanguage?.code === JSON.parse(localStorageLanguge)?.code){
      return
    }
    const fetchQuestions = async () => {
      
      const res = await getPatientQuestions(uuid,patienteLanguage?.code, dispatch)
      if (res?.status === false && res?.message) {
        setErrMsg(res.message)
      }
      setIsLoading(false)
    }
    fetchQuestions()
  }, [patientLanguage?.id])


  if (isLoading) {
    return <PatientLoading />
  }

  if (!isLoading && errMsg) {
    return <Box>
      <Text textAlign='center' fontWeight='bold' my={8} >{errMsg}</Text>
    </Box>
  }
  if (!isLoading && !errMsg && patientQuestions[0] === 'vous avez déjà répondu à vos questions') {
    return <Finish />
  }



  return (
    <Box w='100%' minH='100vh' >
      <Flex position={{ base: 'sticky', lg: 'relative' }} top={0} left={0} zIndex={100} bg='#E3F5FF' py={4} px={{ base: 4, sm: 10, md: 10 }} w='100%' alignItems='center' justifyContent={{ base: 'space-between' }} >
        <CategoriesMenuBar />
        <Heading>FOCUS</Heading>
        <LanguagesBar isLoadingTranslate={isLoadingTranslate} setIsLoadingTranslate={setIsLoadingTranslate} />
      </Flex>
      <Text mt={4} textAlign='center' px={4} w={{ base: '100%', sm: '90%', md: '80%', lg: '70%' }} mx='auto' color='#182F45'>{isVideo === 0 ? descriptions&& descriptions?.length > 0 && descriptions[0]?.first_description :descriptions&& descriptions?.length > 0 && descriptions[0]?.second_description}</Text>
      {isVideo === 0 ? (
        <Video id={id!} setIsVideo={setIsVidoe} />
      ) : (
        <QstWrapper uuid={uuid} />
      )}
    </Box>
  )
}

export default Welcome